import { com } from '@eidu/web'
import Field = com.eidu.entity.field.Field

export type NewFieldData = {
  existing: false
  field: Field
  editable: true
  editableName: boolean
  columnIndex: number
}

export type ExistingFieldData = {
  existing: true
  field: Field
  editable: false
  editableName: boolean
  columnIndex?: number
}

type FieldData = NewFieldData | ExistingFieldData

export const fieldDataFromNewField = (field: Field, columnIndex: number): NewFieldData => ({
  existing: false,
  field,
  editable: true,
  editableName: true,
  columnIndex,
})

export const fieldDataFromExistingField = (field: Field, columnIndex: number | undefined): ExistingFieldData => ({
  existing: true,
  field,
  editable: false,
  editableName: true,
  columnIndex,
})

export default FieldData
